<template>

    <div class="project__wrapper wrapper">
      <div class="bg_project"></div>

      <transition appear>
        <div class="top_title">
          <a class="white_line white_line--gray" href="/#work">Work</a> / <span>{{name}}</span>
        </div>
      </transition>

      <transition appear>
        <a href="/#work" class="project__close">
          <img src="../assets/img/vendor/close.svg" alt="close icon">
        </a>
      </transition>

      <transition appear>
        <main class="project__container container">
          <div class="project_text">
            <div class="project_text-col">
              <h1 class="project_text__title title">{{name}}</h1>
              <a class="project_text__link white_line white_line--gray" target="_blank" href="" v-if="link" rel="nofollow">{{ link.replace('http://', '') }}</a>
            </div>
            <div class="project_text-col">
              <p class="project_text__text text">{{desc}}</p>
              <ul class="project_text__list">
                <li class="project_text__list-item" v-for="item in check_list">{{item | trim}}</li>
              </ul>
            </div>
          </div>
          <div class="project__images">
            <div class="video" v-if="video !== ''">
              <div class="preloader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
              <video :src="video"  autoplay loop muted></video>
            </div>
            <img :src="item.image" alt="project image" v-for="item in images">
          </div>

          <nav class="project__nav">
            <div class="project__nav-col">
              <a class="project__nav-item project__nav-prev" v-if="prev" :data-work-link="prev.slug" :href="'/' + prev.slug + '/'">{{prev.name}}</a>
            </div>
            <div class="project__nav-col" >
              <a class="project__nav-item project__nav-next" v-if="next" :data-work-link="next.slug" :href="'/' + next.slug + '/'">{{next.name}}</a>
            </div>
          </nav>
        </main>
      </transition>
    </div>


</template>

<script>
    import ScrollToPlugin from 'gsap/src/minified/plugins/ScrollToPlugin.min.js'
    import domain, {main_domain} from '../assets/js/config.js'

    export default {
        name: "Project",
        data () {
          return {
            name: '',
            link: '',
            check_list: '',
            desc: '',
            images: '',
            next: '',
            prev: '',
            video: ''
          }
        },
        filters: {
          trim: function (string) {
            return string.trim()
          }
        },
        watch: {
          '$route'(to, from) {
            TweenMax.set('.project__wrapper', {'opacity': 0} );

            const self = this;

            axios.get(domain + '/work/'+ this.$route.params.id)

              .then(function (response) {
                self.name = response.data.item[0].name;
                self.link = response.data.item[0].link;
                self.video = response.data.item[0].video === '' ? '' : domain + '/media/' + response.data.item[0].video;
                self.check_list = response.data.item[0].check_list.split('|');
                self.desc = response.data.item[0].desc;
                self.images = response.data.images;
                self.next = response.data.next[0];
                self.prev = response.data.prev[0];


                self.images.map((e)=>{
                  e.image = domain +'/media/'+ e.image
                });

                document.querySelector('.top_title span').innerHTML = self.name;

                setTimeout(function () {
                  TweenMax.to('.project__wrapper', .3 , {'opacity': 1} );
                  var element =  document.querySelector('.project_text__link');

                  if (typeof(element) != 'undefined' && element != null)
                  {
                    element.setAttribute('href', self.link);
                  }

                  if ($('video').length >= 1) {
                    var video = document.querySelector('video');
                    console.log('video s')

                    video.addEventListener("canplaythrough", function() {
                      console.log('video downloaderd')

                      $('.video').addClass('video--ready')
                    }, false);
                  }

                });


                // SEO
                // ----------------------------------------------------------------------------------
                document.querySelector('meta[name="description"]').setAttribute("content", response.data.item[0].seo_description);
                document.querySelector('meta[name="keywords"]').setAttribute("content", response.data.item[0].seo_content);
                document.title = response.data.item[0].seo_title;
                // ----------------------------------------------------------------------------------

                // Open Graph
                // ----------------------------------------------------------------------------------
                document.querySelector('meta[property="og:title"]').setAttribute("content", response.data.item[0].og_title);
                document.querySelector('meta[property="og:description"]').setAttribute("content", response.data.item[0].og_desc);
                document.querySelector('meta[property="og:image"]').setAttribute("content", domain + '/media/' + response.data.item[0].og_image);
                document.querySelector('meta[property="og:url"]').setAttribute("content", main_domain + '/' + response.data.item[0].slug);
                // ----------------------------------------------------------------------------------

                console.log('123123');


              })
              .catch(function (error) {
                window.location.href = '/404';
              });
          }
        },
        created: function () {

          const self = this;

          axios.get(domain + '/work/'+ this.$route.params.id)

            .then(function (response) {

              self.name = response.data.item[0].name;
              self.link = response.data.item[0].link;
              self.video = response.data.item[0].video === '' ? '' : domain + '/media/' + response.data.item[0].video;
              self.check_list = response.data.item[0].check_list.split('|');
              self.desc = response.data.item[0].desc;
              self.images = response.data.images;
              self.next = response.data.next[0];
              self.prev = response.data.prev[0];

              self.images.map((e)=>{
                e.image = domain +'/media/'+ e.image
              });

              document.querySelector('.top_title span').innerHTML = self.name;

              setTimeout(function () {

                var body = $( "body" );
                var element =  document.querySelector('.project_text__link');

                if (typeof(element) != 'undefined' && element != null)
                {
                  element.setAttribute('href', self.link);
                }

                if ($('video').length >= 1) {
                  var video = document.querySelector('video');
                  console.log('video s')

                  video.addEventListener("canplaythrough", function() {
                    console.log('video downloaderd')

                    $('.video').addClass('video--ready')
                  }, false);
                }


              });
              document.querySelector('#app').style.display = 'block'

              // console.log(response.data.item[0])

              // SEO
              // ----------------------------------------------------------------------------------
              document.querySelector('meta[name="description"]').setAttribute("content", response.data.item[0].seo_description);
              document.querySelector('meta[name="keywords"]').setAttribute("content", response.data.item[0].seo_content);
              document.title = response.data.item[0].seo_title;
              // ----------------------------------------------------------------------------------

              // Open Graph
              // ----------------------------------------------------------------------------------
              document.querySelector('meta[property="og:title"]').setAttribute("content", response.data.item[0].og_title);
              document.querySelector('meta[property="og:description"]').setAttribute("content", response.data.item[0].og_desc);
              document.querySelector('meta[property="og:image"]').setAttribute("content", domain + '/media/' + response.data.item[0].og_image);
              document.querySelector('meta[property="og:url"]').setAttribute("content", main_domain + '/' + response.data.item[0].slug);
              // ----------------------------------------------------------------------------------



            })
            .catch(function (error) {
              window.location.href = '/404';
              console.log(error);
            });
        },

        mounted: function () {

          var controller = null;
          var that = this;

          var body = $( "body" );
          body.addClass('body-project')
          $(window).scroll(function (e) {
            return
          })




          window.scrollTo(0, 0);

            $('.project__close, .top_title a, .header__list-item a').click(function(e) {
              if (that.$route.name === 'Project') {
                var href = $(this).attr('href');
                e.preventDefault();
                e.stopPropagation();


                $(window).bind( "mousewheel", function(e) {
                  e.preventDefault();
                  e.stopPropagation();
                });

                body.addClass('anim_back bg_color');

                setTimeout(function () {
                  go_route()
                }, 400);

                function go_route() {
                  $(window).unbind( "mousewheel");
                  that.$router.push({path: href});
                  body.removeClass('anim_back')
                }
              }

            });

          $(document).on('click', '.project__nav-item', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var id = $(this).attr('data-work-link');

            body.addClass('anim_back');
            TweenMax.to(window, 1, {scrollTo: 0});

            setTimeout(function () {
            go_route();
            }, 400);
            function go_route() {
              that.$router.push({name: 'Project', params: {id: id}});
              body.removeClass('anim_back')
            }

          })


        },

    }
</script>




// WEBPACK FOOTER //
// src/components/Project.vue